export enum EmploymentStatus_Enum {
	"Employed Full Time" = 1,
	"Employed Part Time" = 2,
	"Self Employed" = 3,
	"Armed Forces" = 4,
	"Not Employed" = 5,
	"Retired" = 6,
	"Agency Worker" = 7,
	"Contract Worker" = 8,
	"Sub Contractor" = 9,
	Disability = 10,
	Housewife = 11,
	Student = 12,
	Carer = 13,
	"Non Professional Carer" = 24
}
